import { Game, GameMetadata } from "entities/game/types";
import { QueryDocumentSnapshot } from "firebase/firestore";
import { DocumentData, DocumentSnapshot } from "shared/api/firebase";
import { Translations } from "shared/types/languages";

type GamesDBT = {
  id: number;
  externalId: string;
  productSupplierId: number | null;
  productId: number | null;
  categoryId: string | null;
  productName: string | null;
  name: string | null;
  displayName: string | null;
  demoPlayRestricted: boolean;
  realPlayRestricted: boolean;
  maintenanceModeEnabled: boolean;
  progressiveJackpots: string[];
  translations: Translations;
  isActive: boolean;
  bgImage: string | null;
  logoImage: string | null;
  tags: string[];
  tagTypes: string[];
  metadata?: GameMetadata | null;
  themeTags?: string[];
  themeTagTypes?: string[];
};

type GameDataT = Omit<GamesDBT, "id">;

export class GameDB {
  id: number;
  externalId: string;
  productSupplierId: number | null;
  productId: number | null;
  categoryId: string | null;
  productName: string | null;
  name: string | null;
  displayName: string | null;
  demoPlayRestricted: boolean;
  realPlayRestricted: boolean;
  maintenanceModeEnabled: boolean;
  progressiveJackpots: string[];
  translations: Translations;
  isActive: boolean;
  bgImage: string | null;
  logoImage: string | null;
  tags: string[];
  tagTypes: string[];
  metadata?: GameMetadata | null;
  themeTags?: string[];
  themeTagTypes?: string[];

  constructor(game: QueryDocumentSnapshot | DocumentSnapshot<DocumentData>) {
    if (!game.exists()) {
      throw new Error(`Game ${game.id} does not exist`);
    }

    const data = game.data() as GameDataT;

    this.id = Number(game.id);
    this.name = data.name;
    this.externalId = data.externalId;
    this.productSupplierId = data.productSupplierId;
    this.productId = data.productId;
    this.categoryId = data.categoryId;
    this.productName = data.productName;
    this.displayName = data.displayName;
    this.demoPlayRestricted = data.demoPlayRestricted;
    this.realPlayRestricted = data.realPlayRestricted;
    this.maintenanceModeEnabled = data.maintenanceModeEnabled;
    this.progressiveJackpots = data.progressiveJackpots;
    this.translations = data.translations;
    this.isActive = data.isActive;
    this.bgImage = data.bgImage;
    this.logoImage = data.logoImage;
    this.tags = data.tags;
    this.tagTypes = data.tagTypes;
    this.metadata = data.metadata ?? null;
    this.themeTags = data?.themeTags;
    this.themeTagTypes = data?.themeTagTypes;
  }

  toGame(): Game {
    return {
      id: this.id,
      name: this.name,
      externalId: this.externalId,
      productSupplierId: this.productSupplierId,
      productId: this.productId,
      categoryId: this.categoryId,
      productName: this.productName,
      displayName: this.displayName,
      demoPlayRestricted: this.demoPlayRestricted,
      realPlayRestricted: this.realPlayRestricted,
      maintenanceModeEnabled: this.maintenanceModeEnabled,
      progressiveJackpots: this.progressiveJackpots,
      translations: this.translations,
      isActive: this.isActive,
      bgImage: this.bgImage,
      logoImage: this.logoImage,
      tags: this.tags,
      tagTypes: this.tagTypes,
      metadata: this.metadata,
      themeTags: this.themeTags,
      themeTagTypes: this.themeTagTypes,
    };
  }
}
